import { render, staticRenderFns } from "./ModulePegin.vue?vue&type=template&id=c45c4de6"
import script from "./ModulePegin.vue?vue&type=script&lang=js"
export * from "./ModulePegin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports